import { css, unsafeCSS } from 'lit';
import { theme } from '@atlas/shared/client/ui/core/theming';

export const dimmerStyle = css`
    :host {
        position: absolute;
        display: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        padding: ${unsafeCSS(theme.spacing(2))};
        background-color: rgba(255, 255, 255, 0.8);
        user-select: none;
        will-change: opacity;
        z-index: 1000;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        opacity: 0;
        transition: opacity 0.2s;
    }

    :host([active]) {
        display: flex;
        opacity: 1;
    }

    :host([blurring][active])::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        transition: filter 0.2s;
        filter: blur(3px) opacity(0.5);
    }

    .content {
        user-select: text;
    }
`;
